import React from 'react'
import Helmet from 'react-helmet'
import PageWrapper from '../components/PageWrapper/PageWrapper'
import TextContainer from '../components/TextContainer/TextContainer'
import InputButton from '../components/InputButton/InputButton'
import Inner from '../components/Inner/Inner'
import Divider from '../components/Divider/Divider'
import styles from './RemotePage.module.css'

const RemotePage = props => {
  function createContent() {
    return { __html: props.data.allFile.edges[0].node.childMarkdownRemark.html }
  }

  return (
    <div className={styles.wrapper}>
      <PageWrapper>
        <Helmet title="Remote Access - Dominion Systems, LLC" meta={[]} />
        <Inner>
          <TextContainer>
            <h1>
              {
                props.data.allFile.edges[0].node.childMarkdownRemark.frontmatter
                  .title
              }
            </h1>
            <div dangerouslySetInnerHTML={createContent()} />{' '}
          </TextContainer>
        </Inner>
      </PageWrapper>
    </div>
  )
}

export default RemotePage

export const remoteQuery = graphql`
  query remoteQuery {
    allFile(filter: { sourceInstanceName: { eq: "remote" } }) {
      edges {
        node {
          childMarkdownRemark {
            html
            frontmatter {
              title
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/remote.js